export default "__VITE_ASSET__oUq0kQC8__"